/* -------------------------------
  Mobile Slick Carousel & Color Swatch
-------------------------------- */
(function () {
  const MOBILE_BREAKPOINT = 767;
  const $ = window.jQuery;

  function isMobile() {
    return window.innerWidth <= MOBILE_BREAKPOINT;
  }

  // Parse swatch images
  function parseImagesFromSwatch(swatchEl) {
    let images = [];
    try {
      const arr = JSON.parse(swatchEl?.dataset.productImages || "[]");
      if (Array.isArray(arr) && arr.length) images = arr.filter(Boolean);
    } catch (e) {
      console.warn("Invalid JSON in data-product-images", e);
    }
    return images;
  }

  // Parse full product images (for products with no swatches)
  function parseImagesFromProduct(productItem) {
    let images = [];
    try {
      const arr = JSON.parse(productItem?.dataset.productImages || "[]");
      if (Array.isArray(arr) && arr.length) {
        images = arr.filter(Boolean);
      }
    } catch (e) {
      console.warn("Invalid JSON in data-product-images on product", e);
    }

    if (!images.length) {
      productItem.querySelectorAll(".product-item__image-wrapper img").forEach((img) => {
        if (img.src) images.push(img.src);
      });
    }
    return [...new Set(images)]; // no duplicates
  }

  // Build slider
  function buildCarousel(productItem, images, swatchEl) {
    const imageWrapper = productItem.querySelector(".product-item__image-wrapper");
    if (!imageWrapper) return;

    // Reuse anchor if present
    let anchor = imageWrapper.querySelector(".product-item__aspect-ratio");
    if (!anchor) {
      anchor = document.createElement("a");
      anchor.classList.add("product-item__aspect-ratio");
      imageWrapper.appendChild(anchor);
    }

    // Ensure href is correct
    anchor.href =
      swatchEl?.dataset?.variantUrl ||
      anchor.href ||
      productItem.querySelector("a")?.href ||
      "#";

    // Remove old carousel only
    const oldCarousel = anchor.querySelector(".product-card-carousel");
    if (oldCarousel) {
      if ($(oldCarousel).hasClass("slick-initialized")) {
        $(oldCarousel).slick("unslick");
      }
      oldCarousel.remove();
    }

    // Build new carousel
    const carousel = document.createElement("div");
    carousel.classList.add("product-card-carousel");

    images.forEach((src) => {
      const cell = document.createElement("div");
      const img = document.createElement("img");
      img.src = src;
      // img.loading = "lazy";
      // img.decoding = "async";
      img.loading = "eager";
      img.decoding = "async";
      img.style.width = "100%";
      img.style.height = "100%";
      img.setAttribute("fetchpriority", "high");
      const wrapper = document.createElement("div");
      wrapper.classList.add("fade-wrapper");
      wrapper.appendChild(img);
      cell.appendChild(wrapper);
      carousel.appendChild(cell);
    });

    anchor.appendChild(carousel);

    $(carousel).slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      dots: false,
      arrows: false,
      swipe: true,
      autoplay: false,
      adaptiveHeight: false,
    });

    // Ensure images render before slider adjusts
    // $(carousel).find("img").each(function () {
    //   if (this.complete) {
    //     this.classList.add("loaded");
    //     $(carousel).slick("setPosition");
    //   } else {
    //     this.addEventListener("load", () => {
    //       this.classList.add("loaded");
    //       $(carousel).slick("setPosition");
    //     });
    //   }
    // });

    // Slide hint only if there’s more than 1 image and it's the first product card
    if (
      images.length > 1 &&
      productItem.matches(".collection-only.product-item:first-of-type") &&
      !productItem.dataset.slideHintRemoved
    ) {
      carousel.classList.add("slide-hint-animation");
    }


    // Stop slide hint on interaction
    document.querySelectorAll(".product-card-carousel").forEach((slider) => {
      ["mousedown", "touchstart", "click"].forEach((evt) =>
        slider.addEventListener(evt, stopSlideHint, { once: true })
      );
    });

    function stopSlideHint() {
      document.querySelectorAll(".slide-hint-animation").forEach((el) =>
        el.classList.remove("slide-hint-animation")
      );
      const firstProduct = document.querySelector(".collection-only.product-item:first-of-type");
      if (firstProduct) firstProduct.dataset.slideHintRemoved = "true";
    }
  }

  // Init a single product card
  function initProductItem(productItem) {
    if (!isMobile()) return;
    if (productItem.querySelector(".product-card-carousel.slick-initialized")) return;

    // Always define activeSwatch
    let activeSwatch =
      productItem.querySelector(".collection-only .variant-swatch__item.active") ||
      productItem.querySelector(".collection-only .variant-swatch__item");

    // ✅ Detect if product is on sale (exact match only)
    const tags = (productItem.dataset.productTags || "")
      .toLowerCase()
      .split(",")
      .map((t) => t.trim());
    const isSale = tags.includes("sale");

    // 🖼️ Pick images (FIXED)
    let images = [];

    // 1️⃣ Always respect active swatch first
    if (activeSwatch) {
      images = parseImagesFromSwatch(activeSwatch);
    }

    // 2️⃣ Only apply sale logic if NO active swatch images found
    if (!images.length && isSale) {
      const saleSwatch = Array.from(
        productItem.querySelectorAll(".variant-swatch__item")
      ).find((el) => el.dataset.sale === "true");

      if (saleSwatch) {
        images = parseImagesFromSwatch(saleSwatch);
        activeSwatch = saleSwatch;
      }
    }

    // 3️⃣ Final fallback
    if (!images.length) {
      images = parseImagesFromProduct(productItem);
    }


    // ✅ Build carousel only if we have images
    if (images.length) {
      // Limit to 6 images max
      images = images.slice(0, 6);
      buildCarousel(productItem, images, activeSwatch);
    }
  }


  // Init all product cards
  function initAllProductItems() {
    if (!isMobile()) return;
    document.querySelectorAll(".collection-only.product-item").forEach(initProductItem);
  }

  // Swatch click handler
  document.addEventListener("click", (e) => {
    if (!isMobile()) return;
    const swatch = e.target.closest(".collection-only .variant-swatch__item");
    if (!swatch) return;

    e.preventDefault();
    const productItem = swatch.closest(".collection-only.product-item");
    if (!productItem) return;

    productItem.querySelectorAll(".collection-only .variant-swatch__item.active").forEach((a) =>
      a.classList.remove("active")
    );
    swatch.classList.add("active");

    const images = parseImagesFromSwatch(swatch).slice(0, 6);
    if (images.length) buildCarousel(productItem, images, swatch);
  });

  // Observe product list changes
  const productList = document.querySelector(".product-facet");
  if (productList) {
    const observer = new MutationObserver(() => initAllProductItems());
    observer.observe(productList, { childList: true, subtree: true });
  }

  document.addEventListener("collection:updated", initAllProductItems);
  document.addEventListener("collection:sort", initAllProductItems);
  document.addEventListener("collection:pagination", initAllProductItems);
  window.addEventListener("resize", initAllProductItems);
  document.addEventListener("DOMContentLoaded", initAllProductItems);
})();
